import * as React from 'react';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { GroupDetailTab } from '../../../types/groups/detail';
import { TabInfo } from '../../../types/common/tabs';
import { useCLOSETGroupInfoQuery } from 'hooks/groups/useCLOSETGroupInfoQuery';
import { CircleSpinner } from '@clovirtualfashion/connect-core';
import ContentLayout from '../../../components/common/layouts/ContentLayout';
import TabLayout from '../../../components/common/layouts/TabLayout';
import styled from '@emotion/styled';

const GroupOverviewTabContainer = React.lazy(() => import('./GroupOverviewTabContainer'));
const GroupBillingHistoryContainer = React.lazy(() => import('./GroupBillingHistoryContainer'));

const getTabList = (groupId: string): TabInfo[] => [
  {
    label: 'Overview',
    value: GroupDetailTab.OVERVIEW,
    to: `/groups/${groupId}/${GroupDetailTab.OVERVIEW}`,
  },
  {
    label: 'Billing History',
    value: GroupDetailTab.BILLING_HISTORY,
    to: `/groups/${groupId}/${GroupDetailTab.BILLING_HISTORY}`,
  },
];

const GroupDetailContainer = () => {
  const { tab = GroupDetailTab.OVERVIEW, groupId } =
    useParams<{ tab: GroupDetailTab; groupId: string }>();

  const { data, isError, isLoading } = useCLOSETGroupInfoQuery({ groupId });
  const pageTitle = 'Group Detail';

  if (isLoading) {
    return (
      <ContentLayout pageTitle={pageTitle}>
        <CircleSpinner />
      </ContentLayout>
    );
  }

  if (isError || !data) {
    return (
      <ContentLayout pageTitle={pageTitle}>
        <GroupNameWrapper>
          <Typography variant="h4" gutterBottom display="inline" color={'textSecondary'}>
            Error!
          </Typography>
        </GroupNameWrapper>
      </ContentLayout>
    );
  }

  return (
    <ContentLayout pageTitle={pageTitle}>
      <GroupNameWrapper>
        <Typography variant="h4" gutterBottom display="inline" color={'textSecondary'}>
          {data.groupName}
        </Typography>
      </GroupNameWrapper>
      <TabLayout tabs={getTabList(groupId)} selectedTab={tab}>
        <Suspense fallback="loading...">
          {tab === GroupDetailTab.OVERVIEW && <GroupOverviewTabContainer infoData={data} />}
          {tab === GroupDetailTab.BILLING_HISTORY && (
            <GroupBillingHistoryContainer groupId={data.groupId} groupName={data.groupName} />
          )}
        </Suspense>
      </TabLayout>
    </ContentLayout>
  );
};

export default GroupDetailContainer;

const GroupNameWrapper = styled.div`
  padding-top: 10px;
  margin-bottom: 20px;
`;
